import {
  HostEnvironment,
  PaldeskRemoteVersions,
} from '@paldesk/module-federation/core';
import { HeaderTestRemoteVersion } from '@paldesk/module-federation/remotes-registry';

export class EnvironmentBase {
  static remotes: PaldeskRemoteVersions = {
    ...HeaderTestRemoteVersion,
  };

  static google_analytics_id = '';
  static environment: HostEnvironment = 'test';
  static palfinger_api_management = '';
  static palfinger_app_gateway = '';
  static oidc_clientid = '';
  static oidc_scope = '';

  static application_insights_key = '';
  static application_min_log_level = '';

  static domainsForApiManagementSubsKey: string[];

  static buildId = '';

  static identityServerAuthConf: {
    whitelistedDomains: string[];
    whitelistedRoutes: string[];
    blacklistedRoutes: string[];
  } = {
    whitelistedDomains: [],
    whitelistedRoutes: [],
    blacklistedRoutes: [],
  };

  static LINKS: {
    SECURITY_TOKEN_SERVICE: string;
    POST_LOGOUT_REDIRECT_URI: string;
    PALDESK_BASEPATH: string;
    HOME: string;
    STATUS_PALDESK_PAGE: string;
    APP_NEWS_PATH: string;
    APP_HELP_PATH: string;
    SERVICE_COCKPIT: string;
    PRODUCT_REGISTRATION: string;
    EQUIPMENT_SCREEN: string;
  } = {
    SECURITY_TOKEN_SERVICE: '',
    POST_LOGOUT_REDIRECT_URI: '',
    PALDESK_BASEPATH: '',
    HOME: '',
    STATUS_PALDESK_PAGE: '',
    APP_NEWS_PATH: '',
    APP_HELP_PATH: '',
    SERVICE_COCKPIT: '',
    PRODUCT_REGISTRATION: '',
    EQUIPMENT_SCREEN: '',
  };

  static FEATURE_FLAGS: object = {};

  static USER_MANAGEMENT: {
    ACTIVATION_EMAIL_WARNING_DAYS: string;
  } = {
    ACTIVATION_EMAIL_WARNING_DAYS: '',
  };

  static disable_spotlights = false;
}
